import React from 'react';
import PaymentMeetCreateForm from '@sistemas_metafinanciera/amplify-components-prod/dist/general-components/PaymentMeetCreateForm';

/* Wrapper */
import WrapperConsumer from '../../store';

const Home = (props) => {

    return (
        <div >
            Hola
        </div> 
    )
}
export default WrapperConsumer(Home);